import { useState, useEffect } from 'react'

export const useChatAnimation = () => {
  const [logoVisible, setLogoVisible] = useState(false)
  const [logoAnimated, setLogoAnimated] = useState(false)
  const [inputAnimated, setInputAnimated] = useState(false)

  // Initial logo animation sequence
  useEffect(() => {
    const fadeTimer = setTimeout(() => setLogoVisible(true), 100)
    const moveTimer = setTimeout(() => setLogoAnimated(true), 800)

    return () => {
      clearTimeout(fadeTimer)
      clearTimeout(moveTimer)
    }
  }, [])

  // Trigger input animation when logo is animated
  useEffect(() => {
    if (logoAnimated) {
      const timer = setTimeout(() => setInputAnimated(true), 500)
      return () => clearTimeout(timer)
    }
  }, [logoAnimated])

  return {
    logoVisible,
    logoAnimated,
    inputAnimated,
  }
}
